import i18next from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import commonEN from '../public/locales/en/common.json';
import userDashboardEN from '../public/locales/en/user_dashboard.json';
import _ from 'lodash';

export default {
  initialize,
  changeLanguage,
  tr,
  getCurrentLanguage,
  addLanguageChangedListener,
  removeLanguageChangedListener,
};

let languageChangedListeners = [];

function initialize() {
  return i18next
    // load translation using xhr -> see /public/locales
    // learn more: https://github.com/i18next/i18next-xhr-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      backend: {
        loadPath: process.env.REACT_APP_ASSET_URL + '/locales/{{lng}}/{{ns}}.json',
      },
      fallbackLng: 'en',
      debug: false,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      ns: ['user_dashboard', 'common'],
      defaultNS: 'common',
      fallbackNS: 'common',
      partialBundledLanguages: true,
      resources: {
        en: {
          common: commonEN,
          user_dashboard: userDashboardEN,
        },
      },
    }).then(() => {
    });
}

function changeLanguage(lang) {
  return i18next.changeLanguage(lang).then(() => {
    languageChangedListeners.forEach((changeLanguageFunction) => {
      changeLanguageFunction(lang);
    });
  });
}

function tr(key, options) {
  return i18next.t(key, options);
}

function getCurrentLanguage() {
  return i18next.language;
}

function addLanguageChangedListener(changeLanguageFunction) {
  if (!languageChangedListeners.includes(changeLanguageFunction)) {
    languageChangedListeners.push(changeLanguageFunction);
  }
}

function removeLanguageChangedListener(changeLanguageFunction) {
  languageChangedListeners = _.remove(languageChangedListeners, (f) => {
    return f == changeLanguageFunction;
  });
}



// WEBPACK FOOTER //
// ./src/i18n.js